module.exports = __webpack_public_path__ + "static/media/nozomi-arimura-lesb.7facb007.jpg";